module.exports = __webpack_public_path__ + "static/media/caja.8ea00474.svg";